<template>
    <v-container v-if="value" class="bnft-wishlist-data-table" :class="$mobile ? 'pa-0' : ''">
        <v-container fluid :class="$mobile ? 'pa-0' : ''">
            <v-spacer cols="3"></v-spacer>
            <v-card :elevation="0">
                <v-img v-if="media && media.url" class="white--text align-end" height="400px" lazy-src="https://picsum.photos/id/497/1080/1080" :src="$near.ipfsAdapter(media)">
                    <v-card-title>
                        <span class="text-h5 font-weight-medium">{{ value.name }}</span><span class="text-caption ml-2 align-self-end">({{ value.mutable_id || value.id }})</span>
                    </v-card-title>
                </v-img>
                <v-card-subtitle :class="$mobile ? 'text-h6 pt-0' : 'mt-8 text-h5'" class="pb-0">
                    <div @click="expanded = !expanded" :class="expanded ? '' : 'text-no-wrap text-truncate'">{{ noNickname ? parsedUsername.firstLastPlural : parsedUsername.plural }} Bra Wish List</div>
                </v-card-subtitle>

                <v-card-text v-if="value.description" style="white-space: pre-wrap" class="text--primary font-weight-light font-italic" :class="$mobile ? 'text-h6 mt-4' : 'mt-8 text-h5'">
                    <span v-html="$options.filters.hyperlink(value.description)"></span>
                </v-card-text>

                <v-card-actions></v-card-actions>
            </v-card>
            <v-spacer cols="3"></v-spacer>
        </v-container>
        <v-data-table sort-by="usd" :headers="$mobile ? mobileHeaders : headers" :search="search" :custom-filter="filter" :items="items" :mobile-breakpoint="0" item-key="id.gtin" :items-per-page="25" hide-default-footer :hide-default-header="$route.name !== 'account' || $mobile" :class="$mobile ? '' : 'elevation-1'">
            <template v-slot:[`header.media`]="{ header }">
                <span class="d-flex justify-center text-h5"><i class="material-icons">{{ header.icon }}</i></span>
            </template>
            <template v-slot:[`header.description`]="{ header }">
                <span class="d-flex justify-center text-h5">{{ header.text }}</span>
            </template>
            <template v-slot:[`item.media`]="{
                    item,
                }">
                <v-container class="d-flex justify-self-center pa-0 feathered">
                    <v-img v-if="!$mobile" width="150" height="200" lazy-src="https://picsum.photos/id/497/1080/1080" @click="
                            imageOverlays[overlayId(item)] = !imageOverlays[overlayId(item)]
                        " :src="$near.ipfsAdapter(item.media)"></v-img>
                    <v-overlay z-index="10" :value="isOverlayOn(item)" @click="
                            imageOverlays[overlayId(item)] = !imageOverlays[overlayId(item)]
                        ">
                        <v-img class="rounded-xl" :src="$near.ipfsAdapter(item.media)"></v-img>
                    </v-overlay>
                </v-container>
            </template>
            <template v-slot:[`item.description`]="{ item }">
                <v-card height="225" class="d-flex mb-1">
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <span style="height: 0" class="d-flex justify-center"><a target="_blank" rel="noopener" style="text-decoration: none" href="https://branfts.com/faq?category=wishlist&id=62d88e1a8eb73800011fdb9a">Your wish list item?</a></span>
                                <p class="text-start text-h5">
                                    {{ item.name }}
                                    <sup v-if="item.bra.size">
                                        <span class="font-weight-light">{{item.bra.size.band}}</span><span class="font-weight-medium text-uppercase">{{item.bra.size.cup}}</span>
                                    </sup>
                                </p>
                                <p v-if="item.charity !== undefined" class="text-start text-caption">
                                    <b>charity</b>
                                    {{ item.charity }}
                                </p>
                                <p class="text-start text-body-1" :class="{ 'text-truncate': componentState[componentId('textTruncate', item)] }" @click="toggleComponentState(componentId('textTruncate', item))" :style="$mobile ? 'max-width: 200px' : 'max-width: 700px'">{{ item.description || `I love this bra!` }}
                                    <a style="display: block" class="text-subtitle-1 text-truncate" :href="item.url" rel="noopener" target="_blank">
                                        {{ item.url }}
                                    </a>
                                </p>
                                <p class="text-start">
                                    <span class="caption font-weight-bold">{{ itemId(item.id) }}</span>
                                    <span class="ml-4 text-no-wrap"><span class="text-uppercase">msrp</span> ${{ msrp(item) }}</span>
                                </p>
                                <p class="text-start d-flex align-center">
                                    <v-tooltip right>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="d-flex align-center" v-bind="attrs" v-on="on">
                                                <icon-base height="20" width="20" viewBox="0 0 100 225" icon-name="near">
                                                    <icon-near iconColor="rgba(0, 0, 0, 1)" />
                                                </icon-base>
                                                <span class="ml-1">
                                                    {{ item.nearToFixed }}
                                                </span>
                                            </span>
                                        </template>
                                        {{ item.near }}
                                    </v-tooltip>
                                    <span class="ml-2">(${{ item.usd }})</span>
                                </p>
                            </v-col>
                            <v-col>
                                <bnft-giver-scroll v-if="!$mobile && uniqueItemId(item.id) && !$route.name.match(/account/)" :owner="owner" :uniqueItemId="uniqueItemId(item.id)"></bnft-giver-scroll>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <bnft-progress :class="$mobile ? 'align-self-end' : 'align-self-center mr-2'" :item="item"></bnft-progress>
                    <v-container v-if="$mobile" style="position: absolute; bottom: 0" class="d-flex">
                        <v-btn v-if="isOwner" x-small @click="edit(item)">edit</v-btn>
                        <v-btn x-small :dark="!item.approximateFundingPercentage || item.approximateFundingPercentage < 100 ? true : false" color="notice" :disabled="item.approximateFundingPercentage >= 100 ? true : false" @click="$emit('support', item)">give</v-btn>
                        <bnft-giver-scroll v-if="$mobile && uniqueItemId(item.id) && !$route.name.match(/account/)" :owner="owner" :uniqueItemId="uniqueItemId(item.id)"></bnft-giver-scroll>
                    </v-container>
                    <v-img v-if="$mobile" width="100" max-height="100" style="position: absolute; right: 0" contain class="mt-2 mr-2" lazy-src="https://picsum.photos/id/497/1080/1080" @click="
                            imageOverlays[overlayId(item)] = !imageOverlays[overlayId(item)]
                        " :src="$near.ipfsAdapter(item.media)"></v-img>
                    <v-overlay v-if="$mobile" z-index="10" :value="isOverlayOn(item)" @click="
                            imageOverlays[overlayId(item)] = !imageOverlays[overlayId(item)]
                        ">
                        <v-img class="rounded-xl" max-width="350" contain :src="$near.ipfsAdapter(item.media)"></v-img>
                    </v-overlay>
                </v-card>
            </template>
            <template v-slot:[`item.blank`]="{}"></template>
            <template v-slot:[`item.control`]="{ item }">
                <v-container>
                    <v-btn v-if="isOwner" small @click="edit(item)">edit</v-btn>
                    <v-btn small :dark="!item.approximateFundingPercentage || item.approximateFundingPercentage < 100 ? true : false" color="notice" :disabled="item.approximateFundingPercentage >= 100 ? true : false" @click="$emit('support', item)">give</v-btn>
                </v-container>
            </template>
        </v-data-table>
    </v-container>
</template>
<style>
.bnft-wishlist-data-table
    .v-data-table
    > .v-data-table__wrapper
    > table
    > tbody
    > tr
    > td {
    padding: 0 2px 0 0;
}
.bnft-wishlist-data-table
    .theme--light.v-data-table
    > .v-data-table__wrapper
    > table
    > tbody
    > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
    background: #ffebee;
}
.feathered {
    box-shadow: -5px 0 5px white, 50px 0 5px white;
}
</style>
<script>
import BN from 'bn.js';
import { until } from 'async';
import IconBase from '../components/IconBase.vue';
import IconNear from '../components/IconNear.vue';
import BnftGiverScroll from '../components/BnftGiverScroll.vue';
import BnftProgress from '../components/BnftProgress.vue';

export default {
    name: 'BnftWishlistDataTable',
    props: {
        value: Object,
        search: String,
        noNickname: Boolean,
    },
    components: {
        IconBase,
        IconNear,
        BnftGiverScroll,
        BnftProgress,
    },
    methods: {
        msrp(item) {
            return item?.id?.msrp ? item.id.msrp.toFixed(2) : undefined
        },
        toggleComponentState(component) {
            this.$set(this.componentState, component, !this.componentState[component]);
        },
        filter(value, search, item) {
            const bool = item != null && search != null && JSON.stringify(item).toLowerCase().indexOf(search) !== -1
            return bool
        },
        updateBalances(item) {
            if (item.balance && item.balance[0]) {
                const NEAR = this.$near.utils.format.formatNearAmount(
                    new BN(item.balance[0])
                )
                item.approximateFundingPercentage = Math.min(
                    Number(item?.id?.msrp) === 0 ? 0 : NEAR / Number(item?.id?.msrp) * 100,
                    100
                ).toFixed(2);
                item.usd = this.$near.convertToUSD(NEAR);
                item.near = this.$near.utils.format.formatNearAmount(`${item.balance[0]}`);
                item.nearToFixed = Number(item.near).toFixed(3);
            }
            return item;
        },
        itemId(id) {
            return id?.gtin;
        },
        uniqueItemId(id) {
            return {
                item_id: this.itemId(id),
                wishlist_id: this.value.id
            }
        },
        componentId(componentName, item) {
            return `${componentName}-${this.value.id}:${this.itemId(item.id)}`;
        },
        overlayId(item) {
            return `${this.value.id}:${this.itemId(item.id)}`;
        },
        isOverlayOn(item) {
            if (this.imageOverlays[this.overlayId(item)] === undefined)
                this.$set(this.imageOverlays, this.overlayId(item), false);
            return (
                this.imageOverlays[this.overlayId(item)] && this.flickerTimeout
            );
        },
    },
    watch: {
        items: {
            deep: true,
            handler(items) {
                items &&
                    items.map((item) => {
                        this.updateBalances(item);
                    });
            },
        },
    },
    computed: {
        items() {
            return this?.value?.items?.length
                ? this.value.items.map((item) => ({
                      uniqueId: this.$near.uniqueId(
                          this.value.id,
                          this.itemId(item.id)
                      ),
                      uniqueIdString: `${this.value.id}:${this.itemId(item.id)}`,
                      ...item,
                  }))
                : undefined;
        },
        owner() {
            return this.value?.owner;
        },
        wallet() {
            return this.$near.wallet[process.env.VUE_APP_NEAR_WISHLIST_CONTRACT_ID]
        },
        isOwner() {
            return (
                this.wallet &&
                this.wallet.isSignedIn() &&
                this.wallet.getAccountId() === this.owner
            );
        },
        media() {
            return this.value?.media?.length ? this.value.media[0] : undefined;
        },
        parsedUsername() {
            return this.value?.owner ? this.$near.parseUsername(this.value.owner) : '';
        }
    },
    data: function () {
        return {
            NODE_ENV: process.env.NODE_ENV,
            ipfsCompatible: undefined,
            headers: [
                { icon: `photo`, value: 'media' },
                { text: `What bra would you like?`, value: 'description' },
                { text: ``, value: 'control' },
            ],
            mobileHeaders: [
                { text: `Images`, value: 'media' },
                { text: `What bra would you like?`, value: 'description' }
            ],
            imageOverlays: {},
            currency: {
                default: 'usd',
                current: 'usd',
            },
            flickerTimeout: false,
            componentState: {},
            expanded: undefined,
        };
    },
    mounted() {
        const self = this;
        self.expanded = self.$mobile ? false : true,
        setTimeout(() => (this.flickerTimeout = true), 1500);
        (async function () {
            if (!self.$store.state.lastNearListing?.NEAR?.quote?.USD?.price)
                await self.$backend.getLatestNearListing();
        })();

        until(
            function test(cb) {
                cb(null, self.items);
            },
            function iter(next) {
                setTimeout(() => next(), 500);
            },
            function done() {
                self.items && self.items.forEach(item => self.$set(self.componentState, self.componentId('textTruncate', item), true));
                self.items.map((item) => {
                    self.$set(self.imageOverlays, self.overlayId(item), false);
                    self.updateBalances(item);
                    return item;
                });
            }
        );
    },
};
</script>
